import { neutral10 } from '@leaftrade/leaftrade-component-library';
import styled from 'styled-components';

export const ProductDetailsContentBottomWrapper = styled.div`
  border-top: 1px solid ${neutral10.hex};
  display: flex;
  flex-direction: column;
  flex: 1 0 100%;
`;
